import { LOCAL_STORAGE_USER_DATA_NAME, API_ERROR_MESSAGE } from '../../../constants';
import Actions from '.';
import { post } from '../../../utils/api';

const userLogin = (body, history) => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await post(`admin/login`, body);
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
            }));
            localStorage.setItem(LOCAL_STORAGE_USER_DATA_NAME, JSON.stringify(data.response))
            history.push('/products');
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message,
        }));
    }
});

export default {
    userLogin,
}